export const ANCHOR_TAG_REL_FOR_BLANK_TARGET = "noopener noreferrer";
